<template>
  <aside class="requirement-pool-card">
    <div class="pool-title">
      <a-icon type="trophy" />
      需求竞拍池
      <span class="count">{{ requirementPool.length }}个需求</span>
    </div>
    <div class="requirement-pool">
      <div
        v-for="requirement in requirementPool"
        :key="requirement.source_id"
        :class="[
          'requirement-item',
          {
            active: requirement.status === 2,
            completed: requirement.status === 3,
            failed: requirement.status === 4
          }
        ]"
      >
        <div class="requirement-tag">BR-{{ requirement.source_id }}</div>
        <a class="requirement-title" :href="requirementLink(requirement)" target="_blank">{{ requirement.source_name || '需求标题' }}</a>
        <div class="requirement-meta">
          <div class="demand-info">
            <template v-if="requirement.winner">
              <a-icon type="team" />
              {{ requirement.winner.name }}
            </template>
          </div>
          <div v-if="requirement.status" class="demand-status" :class="venueProductStatus[requirement.status].class">
            {{ venueProductStatus[requirement.status].label }}
          </div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import { venueProductStatus } from '@/utils/venueConstants';

export default {
  name: 'RequirementPool',
  props: {
    requirementPool: {
      type: Array,
      default: () => []
    },
    currentRequirementIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      venueProductStatus
    };
  },
  computed: {
    requirementLink() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: {
            id: record.id
          }
        }).href;
      };
    }
  }
};
</script>

<style lang="less" scoped>
.requirement-pool-card {
  width: 360px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &:hover {
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }
}

.pool-title {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
  margin: 0;

  .anticon {
    color: #165dff;
    font-size: 18px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover .anticon {
    transform: scale(1.1) rotate(5deg);
  }

  .count {
    font-size: 12px;
    color: #86909c;
    background: #f2f3f5;
    padding: 2px 8px;
    border-radius: 999px;
    margin-left: auto;
  }
}

.requirement-pool {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
  overflow-y: auto;
  padding: 12px 16px;
  scrollbar-width: thin;
  scrollbar-color: #4080ff #f2f3f5;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f2f3f5;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4080ff;
    border-radius: 3px;
  }
}

.requirement-item {
  background: #ffffff;
  color: #1d2129;
  border: 1px solid #f2f3f5;
  border-radius: 6px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 0;
    background: linear-gradient(180deg, #165dff, #722ed1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    border-color: rgba(22, 93, 255, 0.1);
  }

  &:hover::before {
    height: 100%;
  }

  &.active {
    border-color: #4080ff;
    background-color: rgba(22, 93, 255, 0.02);
    box-shadow: 0 2px 6px rgba(22, 93, 255, 0.08);
  }

  &.active::before {
    height: 100%;
  }

  &.bidding {
    border-color: #ff7d00;
    background: rgba(255, 125, 0, 0.02);

    .requirement-tag {
      background: #ff7d00;
      color: white;
    }
  }

  &.completed {
    border-color: #00b42a;
    background: rgba(0, 180, 42, 0.02);

    .requirement-tag {
      background: #00b42a;
      color: white;
    }
  }

  &.failed {
    border-color: #86909c;
    background: #f7f8fa;

    .requirement-tag {
      background: #86909c;
      color: white;
    }
  }

  .requirement-tag {
    font-size: 0.7rem;
    font-weight: 600;
    background: #165dff;
    color: white;
    padding: 0.15rem 0.5rem;
    border-radius: 999px;
    display: inline-block;
    margin-bottom: 0.4rem;
    letter-spacing: 0.2px;
  }

  .requirement-title {
    display: block;
    font-size: 0.875rem;
    line-height: 1.25;
    margin-top: 0.3rem;
    font-weight: 600;
    color: #1d2129;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &:hover .requirement-title {
    color: #165dff;
  }

  .requirement-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.7rem;
    color: #86909c;
    margin-top: 0.4rem;
  }

  .demand-info {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    font-weight: 500;
  }

  .demand-status {
    font-size: 0.75rem;
    padding: 0.2rem 0.6rem;
    border-radius: 999px;
    display: inline-block;
    font-weight: 500;
  }

  .status-bidding {
    background-color: rgba(255, 125, 0, 0.1);
    color: #ff7d00;
  }

  .status-wait {
    background-color: rgba(22, 93, 255, 0.1);
    color: #165dff;
  }

  .status-completed {
    background-color: rgba(0, 180, 42, 0.1);
    color: #00b42a;
  }

  .status-failed {
    background-color: rgba(134, 144, 156, 0.1);
    color: #86909c;
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .requirement-pool-card {
    width: 100%;
    min-width: auto;
    max-width: none;
  }
}

@media (max-width: 768px) {
  .pool-title {
    padding: 10px 12px;
  }

  .requirement-pool {
    padding: 10px 12px;
  }
}
</style>
